module.exports = __webpack_public_path__ + "img/abnormal_icon_breathe_h.f34de25e.png";